module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('integrations.title.integrations')))]), (_vm.current_user.email_service_requires_authorization) ? _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(0), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.mailProvider')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.mailProvider')))])]), (_vm.current_user.requireEmailReauthorization()) ? _c('div', {
    staticClass: "table-col table-col-collapsed account-status-tooltip-col",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('span', {
    staticClass: "account-status-alert glyphicon glyphicon-exclamation-sign",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.$t('integrations.tooltip.mailProvider'),
      "data-placement": "top"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('a', {
    staticClass: "btn btn-clean btn-nylas",
    class: {
      'btn-nylas-conected': _vm.email_authorized
    },
    on: {
      "click": _vm.redirectToNylasOauthUrl
    }
  }, [_vm._v(_vm._s(_vm.email_authorized ? _vm.$t('general.actions.disconnect') : _vm.$t('general.actions.connect')))])])])])]) : _vm._e(), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('text-image', {
    attrs: {
      "text": "API",
      "color": "#14948C"
    }
  })], 1), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.api')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.api')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        _vm.show_api_token = !_vm.show_api_token
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.showToken')))])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_api_token),
      expression: "show_api_token"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.show_api_token = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.api')))]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-sm-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.apiToken')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    staticClass: "form-control bcc-input",
    attrs: {
      "id": "api-token",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm.current_user.api_token
    }
  })]), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-copy",
    on: {
      "click": _vm.copyApiToken
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])])])])])]), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(1), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.crm')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.crm')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        return _vm.openBccForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_form_bcc),
      expression: "show_form_bcc"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeForm()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.crm')))]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.has('webhook_url')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.webhook_url),
      expression: "webhook_url"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^(https)://'),
      expression: "'required|regex:^(https)://'"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "webhook_url",
      "type": "text",
      "placeholder": _vm.$t('integrations.label.webhookUrlForm')
    },
    domProps: {
      "value": (_vm.webhook_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.webhook_url = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('webhook_url')),
      expression: "errors.has('webhook_url')"
    }],
    key: "webhook_url",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.webhook_error))])])], 1)]), _c('trigger-stages', {
    attrs: {
      "integration": "webhook",
      "settings": _vm.current_user.webhook_setting.triggers,
      "on_responsibility": _vm.current_user.webhook_setting.user_change
    },
    on: {
      "selected-stages": _vm.setStagesWebhook
    }
  }), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveWebhookUrl()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])]), _c('hr'), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.saveWebhookUrl')))]), _c('div', {
    staticClass: "row vertical-aligned bcc-form"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('crm_setting_bcc_send_email')
    }
  }, [_c('label', {
    attrs: {
      "for": "crm_bcc_send"
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.attributes.crm_setting.bcc_send_email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crm_setting.bcc_send_email),
      expression: "crm_setting.bcc_send_email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "crm_setting.bcc_send_email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.crm_setting.bcc_send_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crm_setting, "bcc_send_email", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('crm_setting_bcc_send_email')),
      expression: "errors.has('crm_setting_bcc_send_email')"
    }],
    key: "crm_setting_bcc_send_email",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('crm_setting_bcc_send_email')))])])], 1), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('crm_setting_bcc_reply_email')
    }
  }, [_c('label', {
    attrs: {
      "for": "crm_bcc_reply"
    }
  }, [_vm._v(_vm._s(_vm.$t('contacts.attributes.crm_setting.bcc_reply_email')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crm_setting.bcc_reply_email),
      expression: "crm_setting.bcc_reply_email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "crm_setting.bcc_reply_email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.crm_setting.bcc_reply_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.crm_setting, "bcc_reply_email", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('crm_setting_bcc_reply_email')),
      expression: "errors.has('crm_setting_bcc_reply_email')"
    }],
    key: "crm_setting_bcc_reply_email",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('crm_setting_bcc_reply_email')))])])], 1)]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveBcc()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(2), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.pipedrive')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.pipedrive')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        return _vm.toIntegration('pipedrive')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(3), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.nectar')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.nectar')))])]), _c('div', {
    staticClass: "table-col detail"
  }), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        return _vm.openConectNectarForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_form_nectar),
      expression: "show_form_nectar"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeForm()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('nectar_api_key')
    }
  }, [_c('label', {
    attrs: {
      "for": "nectar_api_key"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nectar_api_key),
      expression: "nectar_api_key"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nectar_api_key",
      "type": "text",
      "placeholder": _vm.$t('integrations.placeholder.apiKey')
    },
    domProps: {
      "value": (_vm.nectar_api_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nectar_api_key = $event.target.value
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nectar_api_key')),
      expression: "errors.has('nectar_api_key')"
    }],
    key: "nectar_api_key",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('nectar_api_key')))])])], 1)]), _c('div', {
    staticClass: "info info-crm"
  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.nectarFunnelConfig')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 left"
  }, [_c('div', {
    staticClass: "checkbox-inline on-created",
    on: {
      "click": function($event) {
        return _vm.toggleSendTasks()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "send_tasks"
    },
    domProps: {
      "checked": _vm.nectar_setting.send_tasks
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.nectar.sendTasks')))])])])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('nectar_pipeline_id')
    }
  }, [_c('label', {
    attrs: {
      "for": "nectar_pipeline"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.nectarFunnelID')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nectar_setting.pipeline_id),
      expression: "nectar_setting.pipeline_id"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "nectar_setting.pipeline_id",
      "type": "text",
      "placeholder": _vm.$t('integrations.label.nectarFunnelIDPlaceholder')
    },
    domProps: {
      "value": (_vm.nectar_setting.pipeline_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nectar_setting, "pipeline_id", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('nectar_stage_number')
    }
  }, [_c('label', {
    attrs: {
      "for": "nectar_stage_id"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.nectarFunnelStage')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nectar_setting.stage_number),
      expression: "nectar_setting.stage_number"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "nectar_setting.stage_number",
      "type": "text",
      "placeholder": _vm.$t('integrations.label.nectarFunnelStagePlaceholder')
    },
    domProps: {
      "value": (_vm.nectar_setting.stage_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nectar_setting, "stage_number", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group col-md-6",
    class: {
      'has-error': _vm.errors.has('nectar_setting_responsible')
    }
  }, [_c('label', {
    attrs: {
      "for": "nectar_setting_responsible"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.nectarSettingResponsible')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nectar_setting.responsible),
      expression: "nectar_setting.responsible"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control bcc-input",
    attrs: {
      "name": "nectar_setting_responsible",
      "type": "email",
      "placeholder": _vm.$t('integrations.label.nectarSettingResponsiblePlaceholder')
    },
    domProps: {
      "value": (_vm.nectar_setting.responsible)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nectar_setting, "responsible", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nectar_setting_responsible')),
      expression: "errors.has('nectar_setting_responsible')"
    }],
    key: "nectar_setting_responsible",
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('integrations.feedback.nectarSettingResponsibleInvalid')))])])], 1)]), _c('trigger-stages', {
    attrs: {
      "integration": "nectar",
      "settings": _vm.nectar_setting.triggers
    },
    on: {
      "selected-stages": _vm.setStagesNectar
    }
  }), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), (_vm.current_user.nectar_api_key) ? _c('button', {
    staticClass: "pull-right btn btn-danger btn-config",
    on: {
      "click": _vm.removeNectarApiKey
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.saveNectar
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(4), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.salesforce')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.salesforce')))])]), _c('div', {
    staticClass: "table-col detail"
  }), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [(_vm.salesforce_authorized) ? _c('a', {
    staticClass: "btn btn-clean btn-nylas",
    on: {
      "click": function($event) {
        return _vm.toIntegration('salesforce')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))]) : _c('a', {
    staticClass: "btn btn-clean btn-nylas",
    on: {
      "click": function($event) {
        return _vm.openConectSalesForceForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.chooseEnv')))])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_form_salesforce),
      expression: "show_form_salesforce"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.closeForm()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.chooseEnv'))), _c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.chooseEnvOptions')))])]), _c('div', {
    staticClass: "info"
  }, [_c('i', [_vm._v(_vm._s(_vm.$t('integrations.tooltip.chooseEnv')))])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.toggleSandboxTestSf()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": !_vm.salesforce_setting.sandbox_test
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.productionEnv')))])])])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    on: {
      "click": function($event) {
        return _vm.toggleSandboxTestSf()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.salesforce_setting.sandbox_test
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.sandboxEnv')))])])])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('a', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.redirectToSalesforceOauthUrl
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.connect')))])])])]), _c('vtiger'), _c('hubspot'), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('text-image', {
    attrs: {
      "text": "RL",
      "color": "#BC00A4"
    }
  })], 1), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.carousel')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.carousel')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        _vm.show_carousel = !_vm.show_carousel
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_carousel),
      expression: "show_carousel"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.show_carousel = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "info info-crm"
  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.carousel')))])]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#carousel-modal"
    },
    on: {
      "click": _vm.loadCarouselData
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))])])])]), _c('carousel-modal', {
    ref: "carousel_modal",
    attrs: {
      "id": "carousel-modal",
      "modal-title": _vm.modalTitle(),
      "kind": "app"
    },
    on: {
      "savedCarousel": _vm.fillCarousel
    }
  }), _c('rd_station'), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "rd_station_crm"
    }
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(5), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.rdStation')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.rdStation')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        return _vm.toIntegration('rd_station_crm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(6), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.sharpspring')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.sharpspring')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [(_vm.current_user.isSeller()) ? _c('button', {
    staticClass: "btn btn-clean btn-see-carousel",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sp-carousel-modal"
    },
    on: {
      "click": _vm.loadSpCarouselData
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.carouselModal')))]) : _c('button', {
    staticClass: "btn btn-clean btn-conect-rd",
    on: {
      "click": function($event) {
        return _vm.openConectSPForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_form_sp),
      expression: "show_form_sp"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.show_form_sp = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.sharpspringLead')))]), _c('div', {
    staticClass: "info info-rd"
  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.sharpspringLead')))]), _c('div', {
    staticClass: "flow-type-toggler-wrapper"
  }, [_c('div', {
    staticClass: "toggler-inline flow-type-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleUseCarouselSp()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.sharpspring_setting.use_carousel
    }
  }), _c('label', [_vm._v(_vm._s(_vm.use_carousel_sp()))])])])]), _c('div', {
    staticClass: "form-group full-width"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "sp_url",
      "name": "sp_url",
      "type": "text",
      "disabled": !_vm.has_configured_sp_carousel && _vm.sharpspring_setting.use_carousel,
      "readonly": _vm.sp_carousel != null
    },
    domProps: {
      "value": _vm.sp_url
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-copy",
    attrs: {
      "id": "btn-copy-rd-url",
      "disabled": !_vm.has_configured_sp_carousel && _vm.sharpspring_setting.use_carousel
    },
    on: {
      "click": _vm.copyURLsp
    }
  }, [_vm._v(_vm._s(_vm.copied_sp ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))]), (_vm.sharpspring_setting.use_carousel) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#sp-carousel-modal"
    },
    on: {
      "click": _vm.loadSpCarouselData
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))]) : _vm._e()]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.saveSharpSpring
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])]), _c('carousel-modal', {
    ref: "sp_carousel_modal",
    attrs: {
      "id": "sp-carousel-modal",
      "modal-title": _vm.modalTitle(),
      "kind": "sp"
    },
    on: {
      "savedCarousel": _vm.fillSpCarousel
    }
  })], 1), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(7), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.leadlovers')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.leadlovers')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-conect-rd",
    on: {
      "click": function($event) {
        return _vm.openConectLLForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_form_ll),
      expression: "show_form_ll"
    }],
    staticClass: "form"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "id": "closeFormButton",
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.show_form_ll = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "form-group margin-top"
  }, [_c('span', {
    staticClass: "triggers-integrations index"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.leadlovers.receiveContactsTitle')))])])]), _c('div', {
    staticClass: "sub-index intermediate-index"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.leadlovers.receiveText')))]), _c('div', {
    staticClass: "sub-index"
  }, [_vm._v(_vm._s(_vm.$t('integrations.label.contactsViaResponsible')))])]), _c('div', {
    staticClass: "form-group full-width"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "ll_url",
      "name": "ll_url",
      "type": "text"
    },
    domProps: {
      "value": _vm.ll_url
    }
  }), _c('button', {
    staticClass: "btn btn-primary btn-copy",
    attrs: {
      "id": "btn-copy-rd-url"
    },
    on: {
      "click": _vm.copyURLll
    }
  }, [_vm._v(_vm._s(_vm.copied_ll ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))])]), _c('div', {
    staticClass: "row vertical-aligned"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), (_vm.leadloversSet) ? _c('button', {
    staticClass: "pull-right btn btn-danger",
    on: {
      "click": _vm.removeLeadlovers
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": _vm.saveLeadlovers
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])]), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _c('div', {
    staticClass: "table-row table-padding"
  }, [_vm._m(8), _c('div', {
    staticClass: "table-col title"
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.cv')))]), _c('div', {
    staticClass: "light-gray-text"
  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.cv')))])]), _c('div', {
    staticClass: "table-col table-col-collapsed actions"
  }, [_c('button', {
    staticClass: "btn btn-clean btn-config",
    on: {
      "click": function($event) {
        return _vm.toIntegration('cv_crm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icons/logo-esp.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    staticClass: "crm-icon",
    attrs: {
      "src": "/static/images/crm.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/pipedrive.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/nectarcrm.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/salesforce.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/rdstationcrm.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "sharpspring-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/sharpspring.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "sharpspring-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/leadlovers.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-col table-col-collapsed"
  }, [_c('div', {
    staticClass: "cv-box"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/cv_crm.webp"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e3f0824!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations.vue
// module id = 1139
// module chunks = 1